import { FunctionComponent, MouseEvent, PropsWithChildren } from "react";
import styled, { css, CSSProperties } from "styled-components";
import variables from "../../theme/variables";

type OwnProps = {
  disabled?: boolean;
  fill?: string;
  color?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => any;
  className?: string;
  active?: boolean;
  type?: "info" | "error" | "warn" | "success";
  style?: CSSProperties;
};
type Props = PropsWithChildren<OwnProps>;

export const CSSButton = css`
  font-family: "Jura";
  border-radius: 5px;
  padding: ${variables.SPACING * 2}px ${variables.SPACING * 4}px;
  color: ${(props: Props) => props.color};
  opacity: ${(props: Props) => (props.disabled ? "0.5" : "1")};
  background-color: ${(props: Props) => props.fill};
  outline: none;
  border: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
`;

export const StyledButton = styled.button`
  ${CSSButton}

  &:hover {
    background: linear-gradient(to right, #2b32b2, #1488cc);
  }

  ${(props: Props) =>
    props.active &&
    css`
      background: linear-gradient(to right, #2b32b2, #1488cc);

      &:hover {
        background: linear-gradient(to right, #0b1068, #1488cc);
      }
    `}

  &[data-type='error'] {
    background: linear-gradient(to right, #b22b2b, #cc1414);

    &:hover {
      background: linear-gradient(to right, #b22b2b, #650707);
    }
  }

  @media screen and (max-width: 411px) {
    padding: 12px !important;
  }
`;

const Button: FunctionComponent<Props> = ({
  children,
  disabled,
  color,
  fill,
  onClick,
  className,
  active,
  type,
  style,
}) => {
  const getColor = () => color || variables.COLORS.TEXT;
  const getFill = () => fill || variables.COLORS.PRIMARY;

  return (
    <StyledButton
      disabled={disabled}
      onClick={onClick}
      color={getColor()}
      fill={getFill()}
      className={className}
      active={active}
      data-type={type}
      style={style}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
